import { useSelector } from "react-redux"
import { useParams } from "react-router-dom";
import { DataGrid } from "../../../../../components";
import { getLocalized } from "../../../../../redux/localization";
import { adminAccountCallLogs,  adminAccountCallUrl } from "../../../../../services/urls";
import { CreateAccountCallLogForm } from "./create";
import { AccountCallLogDetailPage } from "./detail";


export const AccountCallLogs = () => {
    const localize = useSelector(getLocalized);
    const { Id }: { Id: string } = useParams();
    const columns = [
        {
            dataField: "Account.Email",
            caption: localize.getString("email")
        },
        {
            dataField: "Account.Phone",
            caption: localize.getString("phone")
        },
        {
            dataField: "TalkedWith",
            caption: localize.getString("talkedWidth")
        },
        {
            dataField: "AccountCallLogStatus",
            caption: localize.getString("callStatus")
        },
        {
            dataField: "Note",
            caption: localize.getString("note")
        },
        
        {
            dataField: "NextCallNote",
            caption: localize.getString("nextCallNote")
        },
       
        
       
    ]
    return <DataGrid
        url={adminAccountCallUrl+Id}
        getByIdUrl={adminAccountCallLogs}
        columns={columns}
        refObject={{}}
        create={{
            width: "45%",
            height: "72%",
            createUrl: adminAccountCallLogs,
            title: localize.getString("createCallLog"),
            component: CreateAccountCallLogForm,
            
        }}
        details={{
            width: "50%",
            height: "50%",
            getByIdUrl: adminAccountCallLogs,
            title: localize.getString("callLogDetail"),
            component: AccountCallLogDetailPage,
        }}
        remove={{
            url:adminAccountCallLogs
        }}
        edit={{   
            component : CreateAccountCallLogForm, 
            width:"50%",
            height : "80%",
            editUrl :adminAccountCallLogs,
            title : localize.getString("editCallLog"),
            
            
        }}
        title={localize.getString("callLogs")}
    />
}